import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sIcon.png'
import _imports_1 from '@/assets/uIcon.png'
import _imports_2 from '@/assets/float.png'


const _withScopeId = n => (_pushScopeId("data-v-bd763be6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-departmentid", "data-businessday"]
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-5" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-2 buttonGroup"
}
const _hoisted_5 = {
  title: "Selected Date",
  id: "btnSelectedDate",
  style: {}
}
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "float-end" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Daily Roster Expanded", -1))
const _hoisted_12 = { class: "table table-bordered dailyroster-expanded-summary daily-roster-expanded-print" }
const _hoisted_13 = {
  colspan: "2",
  scope: "row"
}
const _hoisted_14 = {
  colspan: "2",
  scope: "row"
}
const _hoisted_15 = { scope: "row" }
const _hoisted_16 = { scope: "row" }
const _hoisted_17 = { scope: "row" }
const _hoisted_18 = { scope: "row" }
const _hoisted_19 = { scope: "row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { scope: "row" }, null, -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  colspan: "2",
  scope: "row"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_24 = {
  key: 1,
  class: "row"
}
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "table-responsive" }
const _hoisted_27 = { class: "table table-bordered dailyRosterExpanded-skillsummary-grid daily-roster-expanded-print" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { width: "40%" }, "Skill"),
    /*#__PURE__*/_createElementVNode("td", null, "Sched"),
    /*#__PURE__*/_createElementVNode("td", null, "Target"),
    /*#__PURE__*/_createElementVNode("td", null, "Diff"),
    /*#__PURE__*/_createElementVNode("td", null, "% Sched")
  ])
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_30 = {
  key: 2,
  class: "dailyroster-skills-census-summaries"
}
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "dailyRoster-assignments-grid" }
const _hoisted_34 = {
  color: "plain-0",
  class: "p-0 m-0"
}
const _hoisted_35 = { class: "neutable daily-roster-expanded-print" }
const _hoisted_36 = { align: "left" }
const _hoisted_37 = ["slot", "onClick"]
const _hoisted_38 = ["title"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = { style: {"text-decoration":"line-through"} }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["title"]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "associaionIcon",
  title: "Secondary Association"
}, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { key: 2 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "associaionIcon",
  title: "Unassociated"
}, null, -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { key: 3 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "associaionIcon",
  src: _imports_2,
  alt: "Float"
}, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = ["title"]
const _hoisted_55 = ["title"]
const _hoisted_56 = ["title"]
const _hoisted_57 = ["title"]
const _hoisted_58 = ["title"]
const _hoisted_59 = ["title", "onClick"]
const _hoisted_60 = { class: "notes-col" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "tooltiptext" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PlusMetricsReport = _resolveComponent("PlusMetricsReport")!
  const _component_ClockInsReport = _resolveComponent("ClockInsReport")!
  const _component_EditAssignment = _resolveComponent("EditAssignment")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dailyRosterExpandedReportInput, (data, index) => {
      return (_openBlock(), _createElementBlock("div", { key: data }, [
        _createElementVNode("div", {
          class: "dailyRosterDetail-card p-2 mb-2",
          style: {"background-color":"white"},
          "data-departmentid": data.departmentId,
          "data-businessday": _ctx.GetBusinessDay(data.businessDay)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['heading ', index != 0 ? 'dailyRoasterPrintPageBreak': ''])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h5", null, _toDisplayString('(' + data.facilityCoId + ') ' + data.facilityName), 1)
              ]),
              (index == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("button", {
                      title: "Previous Date",
                      id: "btnPreviousDate",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDayClick(false)))
                    }, _toDisplayString('<')),
                    _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.GetSummarySectionDate(data.businessDay)), 1),
                    _createElementVNode("button", {
                      title: "Next Date",
                      id: "btnNextDate",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDayClick(true)))
                    }, _toDisplayString('>'))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h5", _hoisted_7, _toDisplayString('(' + data.departmentCode + ') ' + data.departmentName), 1)
              ])
            ])
          ], 2),
          _hoisted_8,
          (data.rosterSummary != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("table", _hoisted_12, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString('(' + data.facilityCoId + ') ' + data.facilityName), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_14, _toDisplayString('(' + data.departmentCode + ') ' + data.departmentName), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.GetSummarySectionDate(data.businessDay)), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.GetSummaryTime(data.rosterSummary.startDateTime, data.rosterSummary.endDateTime)), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_17, [
                          _createTextVNode("Forecast Census: "),
                          _createElementVNode("b", null, _toDisplayString(_ctx.GetForcastActualstaffTo(data.rosterSummary.forecastCensus)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_18, [
                          _createTextVNode("Actual Census: "),
                          _createElementVNode("b", null, _toDisplayString(_ctx.GetForcastActualstaffTo(data.rosterSummary.actualCensus)), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_19, [
                          _createTextVNode("Staff to: "),
                          _createElementVNode("b", null, _toDisplayString(_ctx.GetForcastActualstaffTo(data.rosterSummary.staffTo)), 1)
                        ]),
                        _hoisted_20
                      ]),
                      (data.rosterSummary.censusNote != null)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                            _createElementVNode("td", _hoisted_22, _toDisplayString(data.rosterSummary.censusNote), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _hoisted_23
              ]))
            : _createCommentVNode("", true),
          (data.rosterSummary != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("table", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("tbody", null, [
                        (data.rosterSummary.skillLevels != null && data.rosterSummary.skillLevels.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(data.rosterSummary.skillLevels, (skill) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: skill }, [
                                (skill.scheduled != 0 || skill.target != 0)
                                  ? (_openBlock(), _createElementBlock("tr", {
                                      key: 0,
                                      class: _normalizeClass([skill.skillLevelDesc.toLowerCase() === 'total' ? 'total-row' : ''])
                                    }, [
                                      _createElementVNode("td", {
                                        class: _normalizeClass([skill.skillLevelDesc.toLowerCase() === 'total' ? 'font-weight-bold' : ''])
                                      }, _toDisplayString(skill.skillLevelDesc), 3),
                                      _createElementVNode("td", {
                                        class: _normalizeClass([skill.skillLevelDesc.toLowerCase() === 'total' ? 'font-weight-bold' : ''])
                                      }, _toDisplayString(skill.scheduled), 3),
                                      _createElementVNode("td", {
                                        class: _normalizeClass([skill.skillLevelDesc.toLowerCase() === 'total' ? 'font-weight-bold' : ''])
                                      }, _toDisplayString(skill.target), 3),
                                      _createElementVNode("td", {
                                        class: _normalizeClass([skill.skillLevelDesc.toLowerCase() === 'total' ? 'font-weight-bold' : '',
                                                                skill.difference < 0 ? 'gridUnderStaff' : skill.difference > 0 ? 'gridOverStaff' : ''])
                                      }, _toDisplayString(skill.difference), 3),
                                      _createElementVNode("td", {
                                        class: _normalizeClass([skill.skillLevelDesc.toLowerCase() === 'total' ? 'font-weight-bold' : '',
                                                                skill.difference < 0 ? 'gridUnderStaff' : skill.difference > 0 ? 'gridOverStaff' : ''])
                                      }, _toDisplayString(skill.schedulePercentage), 3)
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _hoisted_29
              ]))
            : _createCommentVNode("", true),
          (data.assignments != null && data.assignments.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("table", _hoisted_35, [
                          _createElementVNode("colgroup", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                              return (_openBlock(), _createElementBlock("col", {
                                key: column,
                                style: _normalizeStyle({'width': _ctx.columnHeaders[column] })
                              }, null, 4))
                            }), 128))
                          ]),
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                                return (_openBlock(), _createElementBlock("th", { key: column }, _toDisplayString(column), 1))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tbody", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.assignments, (dataItem) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                slot: _ctx.column,
                                key: dataItem,
                                class: _normalizeClass([_ctx.getAssignmentClassForRow(dataItem), "pointer"]),
                                onClick: ($event: any) => (_ctx.onEditingShift(dataItem))
                              }, [
                                _createElementVNode("td", {
                                  title: dataItem.departmentCode,
                                  class: "department-col"
                                }, [
                                  (dataItem.origDeptId !== dataItem.departmentId)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                        _createTextVNode(_toDisplayString(dataItem.departmentCode) + " ", 1),
                                        _hoisted_40,
                                        _createElementVNode("span", _hoisted_41, _toDisplayString(dataItem.origDepartmentCode), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(dataItem.departmentCode), 1))
                                ], 8, _hoisted_38),
                                _createElementVNode("td", {
                                  title: dataItem.staffLastName + ' ' + dataItem.staffFirstName,
                                  class: _normalizeClass(["employee-col", []])
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([(dataItem.origDeptId !== dataItem.departmentId && dataItem.origDeptId === data.departmentId)? 'strikethrough': ''])
                                  }, _toDisplayString(dataItem.staffLastName + ' ' + dataItem.staffFirstName), 3),
                                  (dataItem.charge)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: ['fa', 'user-md'],
                                          size: "sm",
                                          class: "chargeIcon"
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  (dataItem.associationType === _ctx.defaults.secondaryStaff)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, _hoisted_47))
                                    : _createCommentVNode("", true),
                                  (dataItem.associationType === _ctx.defaults.unassociatedStaff)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, _hoisted_50))
                                    : _createCommentVNode("", true),
                                  (dataItem.float)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, _hoisted_53))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_43),
                                _createElementVNode("td", {
                                  title: dataItem.credentialsExpiration
                                }, _toDisplayString(dataItem.credentialsExpiration), 9, _hoisted_54),
                                _createElementVNode("td", {
                                  title: dataItem.skillLevelDescription
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([(dataItem.origDeptId !== dataItem.departmentId && dataItem.origDeptId === data.departmentId)? 'strikethrough': ''])
                                  }, _toDisplayString(dataItem.skillLevelDescription), 3)
                                ], 8, _hoisted_55),
                                _createElementVNode("td", {
                                  title: dataItem.hours,
                                  class: _normalizeClass([(dataItem.isOvertime && !dataItem.cancel) ? 'hours-col overtime': 'hours-col'])
                                }, _toDisplayString(dataItem.hours), 11, _hoisted_56),
                                _createElementVNode("td", {
                                  title: dataItem.employeeType
                                }, _toDisplayString(dataItem.employeeType), 9, _hoisted_57),
                                _createElementVNode("td", {
                                  title: dataItem.fte
                                }, _toDisplayString(dataItem.fte), 9, _hoisted_58),
                                _createElementVNode("td", {
                                  title: dataItem.shiftCode,
                                  onClick: ($event: any) => (_ctx.onEditingShift(dataItem)),
                                  class: _normalizeClass([(dataItem.overtimeShift && !dataItem.cancel) ? 'shift-col overtime': 'shift-col'])
                                }, _toDisplayString(dataItem.shiftCode), 11, _hoisted_59),
                                _createElementVNode("td", _hoisted_60, [
                                  (dataItem.hasNotes)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_61, [
                                        _createElementVNode("span", {
                                          class: "tooltip",
                                          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showToolTip($event)))
                                        }, [
                                          _createVNode(_component_font_awesome_icon, {
                                            icon: ['fa', 'sticky-note'],
                                            size: "sm",
                                            onClick: ($event: any) => (_ctx.onEditingShift(dataItem))
                                          }, null, 8, ["onClick"]),
                                          _createElementVNode("span", _hoisted_62, [
                                            _createTextVNode("Notes: "),
                                            _hoisted_63,
                                            _createTextVNode(" " + _toDisplayString(_ctx.setGridDateFormat(dataItem.notedate)) + " ", 1),
                                            _hoisted_64,
                                            _createTextVNode(" " + _toDisplayString(dataItem.note.length > 50 ? dataItem.note.replace(' ','').substring(0,50) + "..." : dataItem.note), 1)
                                          ])
                                        ], 32)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 10, _hoisted_37))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_65,
          (data.plusMetrics != null)
            ? (_openBlock(), _createBlock(_component_PlusMetricsReport, {
                key: 3,
                plusMetricsReportInput: data.plusMetrics,
                facilityName: data.facilityName,
                departmentName: data.departmentName
              }, null, 8, ["plusMetricsReportInput", "facilityName", "departmentName"]))
            : _createCommentVNode("", true),
          (data.clockIns != null && data.clockIns.shiftClockIns != null && data.clockIns.shiftClockIns.length > 0)
            ? (_openBlock(), _createBlock(_component_ClockInsReport, {
                key: 4,
                clockInsInput: data.clockIns
              }, null, 8, ["clockInsInput"]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1)
      ]))
    }), 128)),
    (_ctx.isEditAssignment)
      ? (_openBlock(), _createBlock(_component_EditAssignment, {
          key: 0,
          assignmentInput: _ctx.assignmentInput,
          assignmentType: _ctx.assignmentType,
          onCloseModal: _ctx.closeEditAssignment
        }, null, 8, ["assignmentInput", "assignmentType", "onCloseModal"]))
      : _createCommentVNode("", true)
  ], 64))
}